import { cn } from "@/lib/utils";
import { Lightbulb } from "lucide-react";

type FreeInBetaTagProps = {
  className?: string;
};

export function FreeInBetaTag({ className }: FreeInBetaTagProps) {
  return (
    <div
      className={cn(
        "py-2 text-xs flex items-center gap-2 border rounded-md border-dashed border-muted-foreground justify-center",
        className,
      )}
    >
      <Lightbulb className="h-4 w-4" />
      <span>Fiberplane is free while in beta</span>
    </div>
  );
}
